import React from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const ProductCard = ({ product }) => {
  const { name, images, model, condition } = product;
  const navigate = useNavigate();

  return (
    <TheProductCard onClick={() => navigate(`/product/${model}`)}>
      <div className="card-image">
        <img src={images?.[0]} alt={name} />
        {condition && <span className="condition-pill">{condition}</span>}
      </div>
      <div className="card-body">
        <p className="card-name">{name}</p>
        <span className="card-sku">Product COde: {model}</span>
        <div className="card-footer">
          <span className="card-cta">View Details &#8594;</span>
        </div>
      </div>
    </TheProductCard>
  );
};

const TheProductCard = styled.div`
  width: 100%;
  background: #fff;
  border: 1px solid #e0dbd3;
  overflow: hidden;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  transition:
    border-color 0.22s,
    box-shadow 0.22s;
  font-family: "Georgia", "Times New Roman", serif;
  background: white;

  &:hover {
    border-color: var(--primary-color);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.07);
  }

  /* ── IMAGE ── */
  .card-image {
    position: relative;
    width: 100%;
    aspect-ratio: 4 / 3;
    background: #ffffff;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      padding: 0.8rem;
      transition: transform 0.5s ease;
    }

    .condition-pill {
      position: absolute;
      top: 0.6rem;
      left: 0.6rem;
      font-family: "Courier New", monospace;
      font-size: 0.58rem;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      background: var(--primary-color);
      color: #f5f2ed;
      padding: 0.2rem 0.55rem;
      pointer-events: none;
    }
  }

  &:hover .card-image img {
    transform: scale(1.04);
  }

  /* ── BODY ── */
  .card-body {
    padding: 0.9rem 1rem 1rem;
    border-top: 1px solid #e0dbd3;
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    flex: 1;

    .card-name {
      font-size: 0.88rem;
      font-weight: 400;
      color: #1c1c1c;
      line-height: 1.4;
      margin: 0;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .card-sku {
      /* font-family: "Courier New", monospace; */
      font-size: 0.65rem;
      letter-spacing: 0.1em;
      color: #b0a898;
    }

    .card-footer {
      margin-top: auto;
      padding-top: 0.7rem;
      border-top: 1px solid #ede8e0;

      .card-cta {
        /* font-family: "Courier New", monospace; */
        font-size: 0.65rem;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: #1c1c1c;
        transition: letter-spacing 0.2s;
        display: flex;
        align-items: center;
      }
    }
  }

  &:hover .card-cta {
    letter-spacing: 0.18em;
  }

  /* ── RESPONSIVE ── */
  @media screen and (max-width: 900px) {
    .card-body {
      padding: 0.8rem 0.9rem 0.9rem;
      .card-name {
        font-size: 0.85rem;
      }
    }
  }

  @media screen and (max-width: 600px) {
    .card-image {
      img {
        padding: 0.6rem;
      }
    }
    .card-body {
      padding: 0.7rem 0.75rem 0.8rem;
      gap: 0.28rem;

      .card-name {
        font-size: 0.78rem;
      }
      .card-sku {
        font-size: 0.6rem;
      }
      .card-footer {
        padding-top: 0.5rem;
      }
      .card-cta {
        font-size: 0.6rem;
      }
    }
  }

  @media screen and (max-width: 420px) {
    .card-body {
      padding: 0.6rem 0.65rem 0.7rem;
      .card-name {
        font-size: 0.75rem;
      }
    }
  }

  @media screen and (max-width: 350px) {
    .card-body {
      padding: 0.5rem 0.6rem 0.6rem;
      .card-name {
        font-size: 0.7rem;
      }
      .card-sku {
        font-size: 0.55rem;
      }
    }
  }
`;

export default ProductCard;
